<div class="subBlockContainer" id="createtenant">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="chid-body">
      <div class="inner-subBlock-wrapper">
        <div id="upload-sku">
          <div class="modal-header">
          </div>
          <div class="select-cart">
          </div>
        <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade show active" id="upload-text" role="tabpanel" aria-labelledby="pills-home-tab">
            <div class="upload-content">
              <p>
                <b>INSTRUCTIONS:</b>
                <a class="download-sample" (click)="downloadInstructionFile()"> Download </a>Detailed Instructions.
              </p>
              <p>
                <b>GUIDELINES:</b>
                <a class="download-sample" (click)="downloadSampleFile()"> Download </a>a sample file that you can modify and upload. Please provide tenant domain, tenant name and an authorised tenant administrator email address. This can be your email address if you have global admin rights for the tenant.
              </p>
              <label>
                <b class="dd-bond">
                  Select a File to Upload Bulk Association:
                </b>
              </label>
              <label id="drag-box" (drop)="drop($event)" (dragover)="allowDrop($event)">
                Choose File or Drag And Drop<input type='file' class="file-display" (change)="onSelectFile($event)">
              </label>
              <!-- <button [disabled]="disableUpload" *ngIf="fileName" [ngbTooltip]="tooltipUpload" [placement]="'bottom'" id="btnUploadExcel" class="button button-red" style="width: 15%; margin: 0 10px">
                Validate Domains<input class="file-display" (click)="onValidateDomains()">
              </button> -->              
              <button class="button button-red button-round button-large auzre-plan-width" style="width: 15%; margin: 0 10px"
                *ngIf="fileName" [disabled]="!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess"
                [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"
                matTooltip="Requires Purchasing Permissions" (click)="onValidateDomains()">
                Validate Domains
              </button>
              <p *ngIf="fileName">
                <b class="dd-bond">
                  {{ fileName }}
                </b>
              </p>
            </div>
          </div>
        

          <div class="my-4" *ngIf="resultTableDataSrc?.length">
            <div class="upload-content">
              <p>
                <a>
                  Please check the status of each tenant to ensure it has been validated successfully.<br/>
                </a>
                <a>
                  Click on the Associate Valid Domains button at the bottom to initiate association. Only validated tenants will initiate association. <br/>
                </a>
                <a>
                  <a class="download-sample" (click)="checkStatusLink()"> This link </a>
                  can be used to complete the tenant association in Microsoft Partner Centre after association is initiated.
                </a>
              </p>
            </div>
            <table mat-table [dataSource]="resultTableDataSrc" >
    
              <ng-container matColumnDef="tenantDescription">
                <th mat-header-cell *matHeaderCellDef width="23%" class="align-left" style="padding-left: 1%; padding-right: 1%;">Tenant Description</th>
                <td class="align-center" mat-cell *matCellDef="let element" width="23%" class="align-left" style="padding-left: 1%; padding-right: 1%; word-break:break-all;">{{ element.tenantDescription }}</td>
              </ng-container>
    
              <ng-container matColumnDef="tenantID">
                <th class="align-center" mat-header-cell *matHeaderCellDef width="33%" class="align-left" style="padding-left: 1%; padding-right: 1%;">Tenant ID</th>
                <td class="align-center" mat-cell *matCellDef="let element" width="33%" class="align-left" style="padding-left: 1%; padding-right: 1%;">
                  <div>
                    {{element.tenantPrimaryDomain}}
                  </div>
                  <div>
                    {{element.tenantGUID}}
                  </div>
                </td>
              </ng-container>
                  
              <ng-container matColumnDef="email">
                <th class="align-center" mat-header-cell *matHeaderCellDef width="18%" class="align-left" style="padding-left: 1%; padding-right: 1%;">Tenant Email</th>
                <td class="align-center" mat-cell *matCellDef="let element" width="18%" class="align-left" style="padding-left: 1%; padding-right: 1%; word-break:break-all;">{{ element.tenantEmail }}</td>
              </ng-container>
    
              <ng-container matColumnDef="status">
                <th class="align-center" mat-header-cell *matHeaderCellDef width="18%" style="padding-left: 1%; padding-right: 1%;">Status</th>
                <td class="align-center" mat-cell *matCellDef="let element"[ngClass]="{'green' : element.statusColour == 'green', 'red': element.statusColour == 'red' }" width="18%" style="padding-left: 1%; padding-right: 1%;"> {{ element.status }} </td>
              </ng-container>
    
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <div class="row filter-wrapper">
              <div style="margin-left: auto!important;">
                <button
                  class="button button-red button-round button-large auzre-plan-width"
                  style="margin: 20px;"
                  [disabled]="!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess"
                  [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                  matTooltip="Requires Purchasing Permissions"
                  (click)="associateValidDomains()"
                >
                  Associate Valid Domains
                </button>
              </div>
            </div>
          </div>

          
          <loading-screen *ngIf="!loadContent" backDropWidth="420" (currentLoadingStatus)="onLoading($event)"></loading-screen>
        </div>
        
        </div>
      </div>
    </div>
  </div>
</div>
